<template>
    <div>
        <MAModal
            v-if="store__showReadOnlyModal"
            id="dashboard-modal"
            :title="`Viewing ${store__datasetReadOnly.datasetLabel}`"
            isLarge
            @close="store__toggleReadOnlyModal()"
        >
            <div
                slot="content"
                class="data-uploader-modal"
            >
                <div class="slds-notify slds-notify_alert slds-theme_alert-texture slds-theme_info slds-p-vertical_small">
                    <span class="slds-assistive-text">info</span>
                    <span class="slds-icon_container slds-icon-utility-user slds-m-right_x-small">
                        <span class="slds-icon ma-icon ma-icon-info ma-icon-large slds-grid slds-grid_vertical-align-center"></span>
                    </span>
                    <h2>If you need to update your CSV data please create a new data source.</h2>
                </div>
                <MASpinner v-if="store__isLoading" />
                <ol class="slds-setup-assistant slds-p-around_large">
                    <MASetupAssistantItem step="1">
                        <div slot="header">
                            Location Headers
                        </div>
                        <div slot="description">
                            <SpatialReferenceRead />
                        </div>
                    </MASetupAssistantItem>
                    <MASetupAssistantItem step="2">
                        <div slot="header">
                            Column Headers
                        </div>
                        <div slot="description">
                            <DataColumnsRead />
                        </div>
                    </MASetupAssistantItem>
                </ol>
            </div>

            <div
                slot="footer"
                class="slds-grid slds-grid_align-spread"
            >
                <button
                    class="slds-button slds-button_brand"
                    @click="store__toggleReadOnlyModal()"
                >
                    Close
                </button>
            </div>
        </MAModal>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import MAModal from '@mapanything/ma-lib/src/vue/components/MAModal.vue';
import MASetupAssistantItem from '@mapanything/ma-lib/src/vue/components/MASetupAssistantItem.vue';
import MASpinner from '@mapanything/ma-lib/src/vue/components/MASpinner.vue';

import SpatialReferenceRead from './SpatialReferenceRead.vue';
import DataColumnsRead from './DataColumnsRead.vue';

export default {
    name: 'Dashboard',
    components: {
        MAModal,
        MASetupAssistantItem,
        MASpinner,
        SpatialReferenceRead,
        DataColumnsRead
    },
    computed: {
        ...mapState({
            store__datasetReadOnly: 'datasetReadOnly',
            store__spatialValuesIndex: 'spatialValuesIndex',
            store__isLoading: 'isLoading',
            store__showReadOnlyModal: 'showReadOnlyModal',
            store__toast: 'toast'
        })
    },
    methods: {
        ...mapMutations({
            store__showSpatialReferencePicker: 'showSpatialReferencePicker',
            store__markSpatialReferenceAsDone: 'markSpatialReferenceAsDone',
            store__toggleReadOnlyModal: 'toggleReadOnlyModal',
            store__toggleSpinner: 'toggleSpinner',
            store__resetSpatialValuesIndex: 'resetSpatialValuesIndex'
        })
    }
};
</script>

<style lang="scss" scoped>
    #dashboard-modal /deep/ .slds-modal__container {

        .slds-modal__content {
            height: 100%;
            padding: 0;
        }
    }

    .slds-pill__icon_container .slds-icon {
        display: flex;
        justify-content: center;
    }

    .slds-setup-assistant__item {
        border-bottom: none;
    }

    .dashboard-modal {
        min-height: 70%;
    }

    .done {
        color: green;
    }

    .fail {
        color: red;
    }
</style>
